import { EntityLock } from "../../entity/EntityLock";

export class DtoLocksPutRes extends EntityLock {}
